import { createContext, useState, useEffect } from 'react';
import { jwtDecode } from "jwt-decode";
import { toast } from 'react-toastify';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });

  const [token, setToken] = useState(() => {
    const stored = localStorage.getItem("token");
    return stored ? JSON.parse(stored) : null;
  });

  const [loadingUser, setLoadingUser] = useState(false);

  const login = ({ userData, jwtToken }) => {
    setUser(userData);
    setToken(jwtToken);
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("token", JSON.stringify(jwtToken));
  };

  const logout = (to = "") => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    if (to) {
      window.location.replace(to);
    }
  };

  const isTokenExpired = (tkn) => {
    try {
      const { exp } = jwtDecode(tkn.access);
      return Date.now() >= exp * 3000;
    } catch (error) {
      console.error("Invalid token:", error);
      return true;
    }
  };

  // periodic auth check
  useEffect(() => {
    const checkAuth = () => {
      const storedUser = localStorage.getItem("user");
      const storedToken = localStorage.getItem("token");

      // console.log("Cheking ...")
        // console.log("user: ",storedUser)
        // console.log("token: ",storedToken)
        

      if (!storedUser || !storedToken) {
        // console.log("Loging out ...")
        
        logout();

        // console.log("user: ",storedUser)
        // console.log("token: ",storedToken)
        // console.log("Loging out complete... No user:No token")
        return;
      }
      
      let parsedToken;
      try {
        parsedToken = JSON.parse(storedToken);
      } catch {
        // console.log("Loging out ...")
        
        logout();

        // console.log("user: ",storedUser)
        // console.log("token: ",storedToken)
        // console.log("Loging out complete... No token")
        return;
      }

      if (isTokenExpired(parsedToken)) {
        // console.log("Loging out ...")
        
        logout();

        // console.log("user: ",storedUser)
        // console.log("token: ",storedToken)
        // console.log("Loging out complete... Old token")
      }
      // console.log("Checking out complete...")

    };

    checkAuth();
    const interval = setInterval(checkAuth, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loadingUser }}>
      {children}
    </AuthContext.Provider>
  );
};
